import {View, Sync} from 'MWC';
import React from 'react';
import Collection from '../collections/main.cll.js';
import CollectionBusiness from '../collections/business.cll';
import {apiback} from '../../../config';

export default class extends View {
    constructor() {
        super();

        this.branchCourses = new Collection();
        this.nbuCourses = new Collection();
        this.processingCourses = new Collection();
        this.businessCourses = new CollectionBusiness();
        this.appCourses = new CollectionBusiness();
    }

    render() {
        const Component = this.props.component;

        if (!this.branchCourses.length) {
            return null;
        } else {
            return (
                <Component
                    {...this.props}
                    branchCourses={this.branchCourses}
                    nbuCourses={this.nbuCourses}
                    processingCourses={this.processingCourses}
                    businessCourses={this.businessCourses}
                    appCourses={this.appCourses}
                >
                    {this.props.children}
                </Component>
            );
        }
    }

    componentWillReady = async resolve => {
        try {
            await this.load();
            return resolve();
        } catch (error) {
            return resolve();
        }
    };

    createRateRequest = key => {
        const Engine = Sync.getEngine('xhr');
        return new Engine({
            url: apiback(key),
            type: 'GET',
            dataType: 'json',
            cache: false
        });
    };

    load = async () => {
        const xhr = this.createRateRequest('API_RATES');
        const xhrBusiness = this.createRateRequest('API_BUSINESS_RATES');

        try {
            const response = await xhr.get();
            const responseBusiness = await xhrBusiness.get();

            this.branchCourses.reset(response.data, {parse: true});
            this.nbuCourses.reset(response.nbu, {parse: true});
            this.processingCourses.reset(response.processing, {parse: true});
            this.businessCourses.reset(responseBusiness.data['8'], {parse: true});
            this.appCourses.reset(responseBusiness.data['18'], {parse: true});
        } catch (error) {
            return error;
        }
    };

    static displayName = 'ExchangeRates.Views.Main';
}
